export const emptyTransfer = {
    target: '',
    winstonQty: '0'
};
//# sourceMappingURL=CreateContract.js.map